import styled from 'styled-components';
import Modal from '../../Modal';
import Button from '../Button';

export const StyledModal = styled(Modal)`
  && {
    width: 85%;
    display: flex;
  }

  & > div {
    width: 100%;
    align-self: center;
  }
`;

export const StyledForm = styled.form`
  width: 100%;
  box-sizing: border-box;
  padding: 15px;

  & input,
  & p {
    width: 100%;
  }

  & input[type='number'] {
    width: 100%;
    padding: 0.5em;
    text-align: center;
    float: none;
  }

  @media (max-width: 380px) {
    & input[type='number'] {
      padding: 0.8em 0.6em;
    }
  }
`;

export const StyledTitle = styled.h3`
  text-align: center;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 0;
`;

export const StyledDescription = styled.dl`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledLabel = styled.label`
  && {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 0;
  }

  &:first-of-type,
  &:last-of-type {
    margin-top: 25px;
  }
`;

export const StyledInput = styled.input`
  && {
    margin-top: 10px;
    margin-bottom: 0;
  }

  &&.error {
    border-color: #CC0000;
    border-width: 2px;
  }
`;

export const StyledErrorWrapper = styled.div`
  position: relative;
`;

export const StyledButton = styled(Button)`
  && {
    font-size: 16px;
    line-height: 16px;
    margin-top: 35px !important;
  }
`;
